import React from 'react';
import {isGerman} from './language';

export const paginationItemRender = (_page: number, type: string, element: React.ReactNode) => {
    if (!React.isValidElement(element) || (type !== 'prev' && type !== 'next')) return element;

    let label: string;
    if (type === 'prev') label = isGerman() ? 'Vorherige Seite' : 'Previous page';
    else label = isGerman() ? 'Nächste Seite' : 'Next page';

    return React.cloneElement(element as React.ReactElement<Record<string, unknown>>, {'aria-label': label});
};
